(function( $ ) {

    var nfSignatureController = Marionette.Object.extend( {

        initialize: function() {
            this.listenTo( Backbone.Radio.channel( 'signature' ), 'init:model', this.initModel );
            this.listenTo( Backbone.Radio.channel( 'signature' ), 'attach:view', this.attachView );
            Backbone.Radio.channel( 'signature' ).reply( 'get:submitData', this.getSubmitData );
            Backbone.Radio.channel( 'signature' ).reply( 'validate:required', this.validateRequired );
            Backbone.Radio.channel( 'signature' ).reply( 'validate:modelData', this.validateModelRequired );
        },

        initModel: function( model ) {
            // This section intentionally left blank.
        },

        attachView: function( view ) {
            var canvas = document.getElementById('signature-' + view.model.get( 'id' ));
            view.model.signaturePad = new SignaturePad( canvas );

            canvas.addEventListener( 'mouseup', function( event ){
                console.log( 'change ' + view.model.get( 'id' ) );
                Backbone.Radio.channel( 'fields' ).request( 'remove:error', view.model.get( 'id' ), 'required-error' );
            });

            view.clearButton = document.getElementById('signature-clear-' + view.model.get( 'id' ));
            view.clearButton.addEventListener( 'click', function( event ) {
                view.model.signaturePad.clear();
            });
        },

        getSubmitData: function( fieldData, field ) {
            fieldData.data = field.signaturePad.toData();
            fieldData.value = field.signaturePad.toDataURL();
            return fieldData;
        },

        validateRequired: function( el, model ) {
            return ! model.signaturePad.isEmpty();
        },

        validateModelRequired: function( model ) {
            return ! model.signaturePad.isEmpty();
        },

    } );

    new nfSignatureController();

})( jQuery );
